import { Button, styled } from '@mui/material';
import { Image, XCircle } from '@phosphor-icons/react';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { UploadService } from '../../../service/UploadService';
import { useNotificationStore } from '../../../store/storeNotifications';

interface MuiUploadtControlledProps {
  uploadProps: {
    name: string;
    label?: string;
    // icon?: Icon;
    accepts: string;
  };
  styles?: any;
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export function MuiUploadtControlled({
  uploadProps,
  styles = {},
}: MuiUploadtControlledProps) {
  const [fileName, setFileName] = useState('');

  const setNotification = useNotificationStore(state => state.setNotification);

  const {
    control,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();

  async function onChange(event: any) {
    const urlFile = await uploadFile(event.target.files);

    setValue(uploadProps.name, urlFile);
  }

  async function uploadFile(files: File[]) {
    const file = files[0];
    const formData = new FormData();
    formData.append('file', file);

    try {
      const { data: response } = await UploadService.uploadFile(formData);

      setFileName(response.name);

      setNotification({
        type: 'success',
        message: 'Image saved successfully',
      });

      return response.src;
    } catch (error) {
      setNotification({
        type: 'error',
        message: 'Error saving image',
      });
    }
  }
  const url = getValues(uploadProps.name);
  const value =
    url !== null && url
      ? getValues(uploadProps.name).split('/').pop()
      : uploadProps.label;

  return (
    <Controller
      control={control}
      name={uploadProps.name}
      defaultValue={''}
      render={({ field }) => (
        <Button
          id={uploadProps.name}
          component="label"
          role={undefined}
          variant="outlined"
          tabIndex={-1}
          endIcon={
              <Image size={20} />
          }
          sx={styles}
          {...field}
          {...uploadProps}
        >
          {value !== '' ? value : uploadProps.label ?? 'Upload'}
          <VisuallyHiddenInput
            type="file"
            onChange={event => onChange(event)}
            multiple={false}
            accept={uploadProps.accepts}
          />
        </Button>
      )}
    />
  );
}
